require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[51],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports
exports.locals = {
	"searchInputClassName": "\"ba-common-searchInput\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(473);


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _SearchInput = _interopRequireDefault(__webpack_require__(474));

exports.default = _SearchInput.default;
exports.SearchInput = _SearchInput.default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _baUiCarbon = __webpack_require__(9);

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _SearchInput = _interopRequireDefault(__webpack_require__(475));

var _StringResource = _interopRequireDefault(__webpack_require__(476));

var _dec, _class, _class2, _temp;

const {
  BaPropTypes
} = _utils.propsUtils;

const _CLASS = _SearchInput.default.searchInputClassName.replace(/"/g, ''); // eslint-disable-line no-underscore-dangle


let SearchInput = (_dec = (0, _utils.debounceInput)(), _dec(_class = (_temp = _class2 = class SearchInput extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_ref", carbonSearchInput => {
      this._input = carbonSearchInput == null ? void 0 : carbonSearchInput.input;
    });
    (0, _defineProperty2.default)(this, "_onChange", e => {
      const {
        onChange,
        // eslint-disable-line react/prop-types
        onClear
      } = this.props; // this really really needs to get done(switch to native onChange behaviour)

      onChange && onChange(e.target.value, e); // this is a clear event

      onClear && e.type !== 'change' && onClear();
    });
  }

  focus() {
    this._input && this._input.focus();
  }

  render() {
    var _ref, _ref2, _ref3;

    const {
      placeHolderText,
      placeholder,
      expanded,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      open,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      icon,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      iconLeft,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      iconRight,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      hideLeftIcon,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      className,
      style,
      'data-tid': datatid = _CLASS,
      // eslint-disable-line react/prop-types
      ...others
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${_CLASS} ${className}`,
      style: style,
      "data-tid": datatid
    }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.Search, (0, _extends2.default)({}, others, {
      "aria-label": (_ref = placeHolderText != null ? placeHolderText : placeholder) != null ? _ref : undefined,
      ref: this._ref,
      onChange: this._onChange,
      labelText: (_ref2 = placeHolderText != null ? placeHolderText : placeholder) != null ? _ref2 : undefined,
      closeButtonLabelText: _StringResource.default.get('clear') // text for the clear(X) icon
      ,
      placeHolderText: (_ref3 = placeHolderText != null ? placeHolderText : placeholder) != null ? _ref3 : undefined
    })));
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  value: _propTypes.default.string,
  onClear: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  placeHolderText: _propTypes.default.string,

  /** deprecated: not applicable to carbon */
  placeholder: BaPropTypes.deprecated('deprecated: use placeHolderText'),

  /** deprecated: not applicable to carbon */
  expanded: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  open: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  icon: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconLeft: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconRight: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  hideLeftIcon: BaPropTypes.deprecated('deprecated: not applicable to carbon')
}), (0, _defineProperty2.default)(_class2, "defaultProps", {
  className: '',
  style: {}
}), _temp)) || _class);
exports.default = SearchInput;

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SearchInput_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(143);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SearchInput_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SearchInput_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SearchInput_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SearchInput_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _SearchInputResources = _interopRequireDefault(__webpack_require__(477));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_SearchInputResources.default);

exports.default = _default;

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

var amdi18n={"__root":{"clear":"Clear"},"__cs":{"clear":"Vymazat"},"__da":{"clear":"Ryd"},"__de":{"clear":"Aufheben"},"__es":{"clear":"Borrar"},"__fi":{"clear":"Tyhjennä"},"__fr":{"clear":"Effacer"},"__hr":{"clear":"Isprazni"},"__hu":{"clear":"Törlés"},"__it":{"clear":"Annulla"},"__ja":{"clear":"クリア"},"__kk":{"clear":"Тазалау"},"__ko":{"clear":"지우기"},"__nb":{"clear":"Fjern"},"__nl":{"clear":"Verwijderen"},"__no":{"clear":"Fjern"},"__pl":{"clear":"Wyczyść"},"__pt":{"clear":"Limpar"},"__pt-br":{"clear":"Limpar"},"__ro":{"clear":"Curăţare"},"__ru":{"clear":"Очистить"},"__sl":{"clear":"Počisti"},"__sv":{"clear":"Radera"},"__th":{"clear":"เคลียร์"},"__tr":{"clear":"Temizle"},"__zh":{"clear":"清除"},"__zh-cn":{"clear":"清除"},"__zh-hk":{"clear":"清除"},"__zh-mo":{"clear":"清除"},"__zh-sg":{"clear":"清除"},"__zh-tw":{"clear":"清除"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[472,0]]]);
});